"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrevious = void 0;
// (C) 2021 GoodData Corporation
var react_1 = require("react");
/**
 * Hook for tracking the previous value of the React component prop.
 * This is useful as a replacement for the componentWillReceiveProps lifecycle method.
 * See: https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 * @internal
 */
exports.usePrevious = function (props) {
    var previousProps = react_1.useRef(props);
    react_1.useEffect(function () {
        previousProps.current = props;
    });
    return previousProps.current;
};
//# sourceMappingURL=usePrevious.js.map